"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Module_1 = require("./components/Module");
var EmptyPage_1 = require("./components/EmptyPage");
var ssrcontext_1 = require("ssrcontext");
var url_1 = require("utils/url");
var resizer_1 = require("mobile/utils/browser/resizer");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var website_1 = require("utils/website");
var debug_1 = require("utils/debug");
var banner_1 = require("utils/playground/banner");
var app_1 = require("services/page/app");
var admin_1 = require("services/page/admin");
var s = require("./index.scss");
var moduleTypes = [
    admin_1.TModuleType.TPageTitleLineType,
    admin_1.TModuleType.TQuickNav,
    admin_1.TModuleType.TSwiper,
    admin_1.TModuleType.TMagicBannerType,
    admin_1.TModuleType.TMagicBannerTwo,
    admin_1.TModuleType.TMultiProductModuleType,
    admin_1.TModuleType.TMultiFlash,
    admin_1.TModuleType.TCountdownBanner,
    admin_1.TModuleType.TRichText,
    admin_1.TModuleType.TMagicVoucher,
    admin_1.TModuleType.TStickBotomTab,
    admin_1.TModuleType.TEvent,
    admin_1.TModuleType.TCoupon
];
var MegatronFrontForMobile = (function (_super) {
    __extends(MegatronFrontForMobile, _super);
    function MegatronFrontForMobile(props) {
        var _this = _super.call(this, props) || this;
        _this.topMap = {};
        _this.moduleMap = [];
        _this.onResizeHandler = function () {
            resizer_1.default();
        };
        _this.setTopMap = function (index, top) {
            _this.topMap[index] = top;
        };
        _this.addModuleMap = function (index, item, link) {
            _this.moduleMap[index - 1] = {
                item: item,
                link: link
            };
        };
        _this.hasTitle = function (moduleList) {
            var hasTitle = false;
            moduleList.forEach(function (item) {
                if (item.type === admin_1.TModuleType.TPageTitleLineType) {
                    hasTitle = true;
                }
            });
            return hasTitle;
        };
        _this.navFixed = function (moduleList) {
            var navFixed = false;
            moduleList.forEach(function (item) {
                if (item.type === admin_1.TModuleType.TQuickNav) {
                    if (item.layout && item.layout.stickToTop) {
                        navFixed = true;
                    }
                }
            });
            return navFixed;
        };
        if (_this.frontPlayground) {
            var _a = _this.frontPlayground, _b = _a.modules, modules = _b === void 0 ? [] : _b, page = _a.page;
            var moduleList = modules.filter(function (v) { return moduleTypes.includes(v.type); });
            var navFixed = _this.navFixed(moduleList);
            var hasTitle = _this.hasTitle(moduleList);
            _this.state = {
                navFixed: navFixed,
                hasTitle: hasTitle,
                moduleList: moduleList,
                overAllBgc: page && page.ui && page.ui.bgColor ? page.ui.bgColor : "#f7f7f7",
                pageDisabled: page && page.isDisable,
                activityId: page && page.groupId
            };
            return _this;
        }
        _this.state = {
            moduleList: null,
            navFixed: false,
            hasTitle: false,
            overAllBgc: "",
            pageDisabled: false,
            activityId: ""
        };
        return _this;
    }
    MegatronFrontForMobile.prototype.componentDidMount = function () {
        var _this = this;
        if (debug_1.isLocalDevelop() || website_1.isLT() || ssrcontext_1.isSSR()) {
            resizer_1.default();
            window.addEventListener("resize", this.onResizeHandler);
        }
        if (this.frontPlayground) {
            return;
        }
        var id = (this.props.id || url_1.getSearchParamValue("id")).trim();
        if (!id) {
            return null;
        }
        var version = url_1.getSearchParamValue("version") ? url_1.getSearchParamValue("version") : undefined;
        var params = {
            id: id,
            version: version,
            meta: {
                catalog: undefined,
                lang: undefined,
                client: undefined,
                priceSymbol: undefined
            }
        };
        params = {
            id: id,
            version: version,
            meta: {
                catalog: isomorphismConstant_1.default.country || isomorphismConstant_1.default.countryCode,
                lang: isomorphismConstant_1.default.language,
                client: website_1.isPC() ? "web" : "mweb",
                priceSymbol: isomorphismConstant_1.default.currency
            }
        };
        app_1.GetFrontPlayground(params).then(function (_a) {
            var _b = _a.modules, modules = _b === void 0 ? [] : _b, page = _a.page;
            var moduleList = modules.filter(function (v) { return moduleTypes.includes(v.type); });
            var navFixed = _this.navFixed(moduleList);
            var hasTitle = _this.hasTitle(moduleList);
            _this.setState({
                navFixed: navFixed,
                hasTitle: hasTitle,
                moduleList: moduleList,
                overAllBgc: page && page.ui && page.ui.bgColor ? page.ui.bgColor : "#f7f7f7",
                pageDisabled: page && page.isDisable,
                activityId: page && page.groupId
            });
        });
    };
    Object.defineProperty(MegatronFrontForMobile.prototype, "frontPlayground", {
        get: function () {
            return this.props.SSRPayload && this.props.SSRPayload.frontPlayground;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MegatronFrontForMobile.prototype, "frontModules", {
        get: function () {
            return this.props.SSRPayload && this.props.SSRPayload.frontModules;
        },
        enumerable: false,
        configurable: true
    });
    MegatronFrontForMobile.prototype.render = function () {
        var _this = this;
        var _a = this.state, moduleList = _a.moduleList, navFixed = _a.navFixed, hasTitle = _a.hasTitle, overAllBgc = _a.overAllBgc, pageDisabled = _a.pageDisabled, activityId = _a.activityId;
        if (!moduleList) {
            return React.createElement("img", { src: banner_1.GetEmptyImage(), style: { width: "100%" } });
        }
        if (!moduleList) {
            return null;
        }
        if ((moduleList && moduleList.length === 0) || pageDisabled) {
            return React.createElement(EmptyPage_1.default, null);
        }
        console.log("此为新的资源路径");
        return (React.createElement("div", { className: s.container, style: { backgroundColor: overAllBgc } }, moduleList.map(function (item, i) {
            var moduleDetailFromServerRender = _this.frontModules && _this.frontModules.find(function (m) { return m.id === item.id; });
            return (React.createElement(Module_1.default, { key: i, simpleModule: item, index: i, navFixed: navFixed, setTopMap: _this.setTopMap, topMap: _this.topMap, hasTitle: hasTitle, moduleMap: _this.moduleMap, addModuleMap: _this.addModuleMap, overAllBgc: overAllBgc, id: activityId, pageId: _this.frontPlayground && _this.frontPlayground.page.id, moduleDetailFromServerRender: moduleDetailFromServerRender }));
        })));
    };
    return MegatronFrontForMobile;
}(React.Component));
exports.default = MegatronFrontForMobile;
